import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AdminAuthProvider, useAdminAuth } from '../../hooks/useAdminAuth';

import DashboardLayout from '../../components/admin/DashboardLayout';
import Login from './Login';
import Dashboard from './Dashboard';
import Personas from './Personas';
import Chats from './Chats';
import Questions from './Questions';
import EmailThreads from './EmailThreads';

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { isAuthenticated, isLoading } = useAdminAuth();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-xl text-gray-600">Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }

  return <>{children}</>;
};

const AdminRoutes: React.FC = () => {
  return (
    <AdminAuthProvider>
      <Routes>
        <Route path="/login" element={<Login />} />

        <Route
          path="/"
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/admin/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="personas" element={<Personas />} />
          <Route path="chats" element={<Chats />} />
          <Route path="questions" element={<Questions />} />
          <Route path="email-threads" element={<EmailThreads />} />
          <Route
            path="research"
            element={<div className="p-4">Research Analytics (Coming Soon)</div>}
          />
        </Route>

        <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
      </Routes>
    </AdminAuthProvider>
  );
};

export default AdminRoutes;
